import { formatDate } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BaseService } from '../../services';
import { I18Service } from '../../services/i18Service';
// import { comment } from '../comment-section/Models/comment';
import { Statistics } from './Model/statistics';

@Component({
  selector: 'app-interaction',
  templateUrl: './interaction.component.html',
  styleUrls: ['./interaction.component.scss']
})
export class InteractionComponent implements OnInit, OnDestroy, OnChanges {

  private subscriptions: Subscription[] = [];

      lang = this.baseService.currentLang || localStorage.getItem('lang') || 'ar';


  @Input() entityId: string = "";
  @Input() itemId: string = "";
  @Input() itemUrl: string = "";
  // _referenceId = environment.ReferenceId;
  // model: comment;
  statistics: Statistics = new Statistics();
  hiriDate: string;
  time: string;
  hideRating = false;
  hideHelp = false;
  ratingCount = 0;
  userRating: any[] = [];
  userHelpful: any[] = [];
  constructor(
    private translate: TranslateService,
    private i18Service: I18Service,
    private baseService: BaseService,
    private router: Router) {
      this.translate.use(this.lang);


  }
  ngOnChanges(changes: SimpleChanges): void {

    // if (this.entityId == environment.Entities.EntrancePermits && (this.itemUrl != null || this.itemUrl != undefined)) {
    //   this.saveInteractionStatistics('Permits');
    // }
    if (this.entityId != null) {
      // this.getStatistics();
    }
    this.checkUserRating();
    this.checkUserHelpful();
  }

  ngOnInit(): void {
    let subscription = this.i18Service.getLocalEvent()
      .subscribe(local => this.translate.use(local))
    this.subscriptions.push(subscription);



    this.baseService.getLangData().subscribe(data => {
      this.changeLagView(data.lang);

     });

  }
  changeLagView(lang){
   this.lang = lang;
    this.translate.use(this.lang);

    this.time = formatDate(this.statistics.latestUpdate, "h:mm a", "en-US");
    let latestUpdateDate = new Date(this.statistics.latestUpdateString);
    latestUpdateDate = new Date(latestUpdateDate.setDate(latestUpdateDate.getDate() - 1))
    this.hiriDate = this.baseService.convertDateToHijri(this.lang, latestUpdateDate);

  }

  checkUserRating() {
    let userRating = localStorage.getItem('userRating')
    if (userRating) {
      this.userRating = JSON.parse(localStorage.getItem('userRating'));
      // if (this.userRating.length > 0) {
      //   let item = this.userRating.find(obj => obj.itemUrl == this.itemUrl && obj.itemId == this.itemId && obj.entityId == this.entityId && obj.referenceId == this._referenceId);
      //   if (item)
      //     this.hideRating = true;
      //   else this.hideRating = false;
      // }

    }
  }

  checkUserHelpful() {
    let userHelpful = localStorage.getItem('userHelpful')
    if (userHelpful) {
      this.userHelpful = JSON.parse(localStorage.getItem('userHelpful'));
      // if (this.userHelpful.length > 0) {
      //   let item = this.userHelpful.find(obj => obj.itemUrl == this.itemUrl && obj.itemId == this.itemId && obj.entityId == this.entityId && obj.referenceId == this._referenceId);
      //   if (item)
      //     this.hideHelp = true;
      //   else this.hideHelp = false;
      // }

    }

  }

  // getStatistics() {
  //   this.model = new comment();
  //   this.model.entityId = this.entityId;
  //   this.model.referenceId = this._referenceId;
  //   this.model.id = this.itemId;
  //   this.model.itemUrl = this.itemUrl;

  //   let subscription = this.baseService.post('Statistics/GetEntitiesStatistics', this.model)
  //     .subscribe({
  //       next: (res: any) => {
  //         if (res.output) {
  //           this.statistics = res.output.Statistics;

  //           this.time = formatDate(this.statistics.latestUpdate, "h:mm a", "en-US");
  //           let latestUpdateDate = new Date(this.statistics.latestUpdateString);
  //           latestUpdateDate = new Date(latestUpdateDate.setDate(latestUpdateDate.getDate() - 1))
  //           this.hiriDate = this.baseService.convertDateToHijri(this.lang, latestUpdateDate);
  //           this.ratingCount = this.statistics.ratingCount;
  //         }

  //       }
  //       , error: (error: string) => {
  //          ;
  //       }
  //     });
  //   this.subscriptions.push(subscription);
  // }

  // insertRate(value: number) {
  //   if (this.hideRating)
  //     return;
  //   let model = {
  //     entityId: this.entityId,
  //     referenceId: this._referenceId,
  //     itemId: this.itemId,
  //     itemUrl: this.itemUrl,
  //     value: value
  //   }
  //   this.hideRating = null;
  //   if (this.entityId != null && value > 0) {
  //     let subscription = this.baseService.post('Rates/InsertRates', model).subscribe({
  //       next: (res: any) => {

  //         if (res.header.success) {
  //           this.hideRating = true;
  //           this.ratingCount += 1;
  //           this.userRating.push(model);
  //           localStorage.setItem('userRating', JSON.stringify(this.userRating));
  //           // this.getStatistics()
  //         }
  //         else
  //           this.hideRating = false;
  //       },
  //       error: (error: string) => {   }
  //     });

  //     this.subscriptions.push(subscription);
  //   }
  // }

  // setHelpfulOrNot(value: boolean) {
  //   let model = {
  //     entityId: this.entityId,
  //     referenceId: this._referenceId,
  //     itemId: this.itemId,
  //     itemUrl: this.itemUrl,
  //     isHelpful: value
  //   }
  //   if (this.entityId != null) {
  //     let subscription = this.baseService.post('Statistics/SetHelpfulOrNot', model).subscribe({
  //       next: (res: any) => {

  //         if (res.header.success) {
  //           this.hideHelp = true;
  //           this.userHelpful.push(model);
  //           localStorage.setItem('userHelpful', JSON.stringify(this.userHelpful));

  //         }
  //         else
  //           this.hideHelp = false;
  //       },
  //       error: (error: string) => {   }
  //     });

  //     this.subscriptions.push(subscription);
  //   }

  // }

  // saveInteractionStatistics(routeEntity: string) {
  //   this.model = new comment();
  //   this.model.entityId = this.entityId;
  //   this.model.referenceId = this._referenceId;
  //   this.model.itemUrl = this.itemUrl;
  //   this.model.statisticsType = 1;

  //   let subscription = this.baseService.post(routeEntity + '/SaveInteractionStatistics', this.model)
  //     .subscribe({
  //       next: (res: any) => {

  //       }
  //       , error: (error: string) => {
  //          ;
  //       }
  //     });
  //   this.subscriptions.push(subscription);
  // }

  ngOnDestroy(): void {
    for (let subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }


}
